import { render, staticRenderFns } from "./CompanyItemList.vue?vue&type=template&id=c2a039ca"
import script from "./CompanyItemList.vue?vue&type=script&lang=ts"
export * from "./CompanyItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports